import toggleModal from '@/scripts/utils/toggle-modal';
import swiperSliderInit from '@/scripts/lib/swiper-slider';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd';
import _debounce from 'lodash/debounce';
import './GalleryModal.scss';

export default class GalleryModal {
  constructor() {
    this.$trigger = null;
    this.$modal = $('[data-role*="gallery-modal-element"]');
    this.$modalSlidesContainer = this.$modal.find('[data-role="slides-container"]');
    this.$rootElement = $(document.documentElement);
    this.$top = this.$modal.find('[data-role*="modal-top"]');
    this.$main = this.$modal.find('[data-role*="modal-main"]');
    this.$bot = this.$modal.find('[data-role*="modal-bot"]');
    this.slider = null;

    this.init();
  }

  toggleStatus() {
    this.$rootElement.toggleClass('gallery-modal-opened');
    return toggleModal(
      this.$rootElement.hasClass('gallery-modal-opened'),
      null,
      this.$modal[0],
    );
  }

  updateTrigger() {
    const that = this;
    this.$trigger = $('[data-role*="gallery-modal-trigger"]');
    this.$trigger.on('click', function (e) { that.triggerHandler(e, this); }); // eslint-disable-line func-names
  }

  initSlider(el) {
    const { params, title } = el.dataset;
    const { type, url, data } = JSON.parse(params);
    this.$modal.addClass('is-loading');
    $.ajax({
      type,
      url,
      data,
      success: (result) => {
        this.$modalSlidesContainer.append(result);
        this.slider = swiperSliderInit({
          swiperTitle: title,
          slidesPerView: 1,
          spaceBetween: 30,
          speed: 1000,
          pagination: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          selector: 'modal-gallery',
        })[0].dom7ElementDataStorage.swiper;
        imagesLoaded(this.$modal[0], () => {
          this.resize();
          this.$modal.removeClass('is-loading');
        });
      },
    });
  }

  destroySlider() {
    this.$modal.one('transitionend', () => {
      this.slider.destroy();
      this.$modalSlidesContainer.children().remove();
    });
  }

  resize() {
    this.$main.css({
      height: window.innerHeight - this.$top.height() - this.$bot.height(),
    });
  }

  triggerHandler(e, element) {
    if (e) e.preventDefault();
    const { title } = element.dataset;
    if (title) {
      this.initSlider(element);
    } else {
      this.destroySlider();
    }
    return this.toggleStatus();
  }

  init() {
    window.addEventListener('resize', _debounce(() => this.resize(), 50));
    this.updateTrigger();
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/GalleryModal/GalleryModal.js